import ConfluenceSourceIcon from "../../assets/components/sources/ConfluenceSourceIcon";

const ConfluenceLogomark = ({ height }: { height: number }) => {
  return <ConfluenceSourceIcon height={height} />;
};

export default ConfluenceLogomark;
